import React from 'react'

import { FilterBox, FilterBoxProps } from '@octane/spark'

import { Container } from './CustomFilterBox.styled'

export default function CustomFilterBox(
    props: Readonly<
        Omit<
            FilterBoxProps,
            | 'open'
            | 'actionLabel'
            | 'hideCounterWhenNoItemsSelected'
            | 'showDropdownToggle'
            | 'allowSorting'
        >
    >,
): JSX.Element {
    return (
        <Container>
            <FilterBox
                open={false}
                actionLabel="Apply Filters"
                hideCounterWhenNoItemsSelected
                allowSorting={false}
                showDropdownToggle
                {...props}
            />
        </Container>
    )
}
